type Environment = "DEV" | "STAGING" | "PROD";

export const getApiBaseUrl = (): string => {
    const env = (import.meta.env.VITE_ENVIRONMENT as Environment | undefined)
        ?.toUpperCase();

    switch (env) {
        case "DEV":
            return import.meta.env.VITE_DEV_API_URL;
        case "STAGING":
            return import.meta.env.VITE_STAGING_API_URL;
        case "PROD":
            return import.meta.env.VITE_PROD_API_URL;
        default:
            console.warn(
                `[getApiBaseUrl] Unknown VITE_ENVIRONMENT="${import.meta.env.VITE_ENVIRONMENT}". Falling back to DEV.`,
            );
            return import.meta.env.VITE_DEV_API_URL;
    }
};

export const API_BASE_URL = getApiBaseUrl() ?? "http://localhost:8000";
export const ENVIRONMENT =
    (import.meta.env.VITE_ENVIRONMENT as Environment | undefined)
        ?.toUpperCase() || "DEV";

export const WS_BASE_URL = API_BASE_URL
    .replace(/^https:/i, "wss:")
    .replace(/^http:/i, "ws:");
